import React, { Fragment, useState, useMemo } from "react"; // useMemo eklendi
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createUser } from "../../slices/apps/userSlice";

// utils
import logger from "../../utils/logger";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// react select
import Select from "react-select";
const getSelectStyles = (validation, fieldName) => ({
  control: (base, state) => ({
    ...base,
    borderColor:
      validation.touched[fieldName] && validation.errors[fieldName]
        ? "#e30a17"
        : state.isFocused
          ? "#80bdff"
          : "#e9ebec",
  }),
});

// react input mask
import { IMaskInput } from "react-imask";

const AddModal = () => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { roles, createUserLoading } = useSelector((state) => {
    return {
      roles: state.user?.roles,
      createUserLoading: state.user?.createUserLoading || false,
    };
  }, shallowEqual);

  const roleOptions = useMemo(() => {
    if (!roles) {
      return [];
    }
    return roles.map((role) => ({
      value: role.id,
      label: role.name,
    }));
  }, [roles]);

  function toggle_modal(e) {
    if (e) {
      validation.resetForm();
      setShowPassword(false);
      setModal(true);
    } else {
      setModal(false);
    }
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      nameSurname: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      roleId: "",
    },

    validationSchema: Yup.object({
      nameSurname: Yup.string()
        .max(100, "Ad Soyad en fazla 100 karakter olabilir.")
        .required("Lütfen ad ve soyad giriniz."),
      phoneNumber: Yup.string()
        .max(20, "Telefon numarası en fazla 20 karakter olabilir.")
        .required("Lütfen telefon numarası giriniz."),
      password: Yup.string()
        .min(6, "Şifre en az 6 karakter olmalıdır.")
        .required("Lütfen bir şifre belirleyiniz."),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Şifreler eşleşmiyor.")
        .required("Lütfen şifrenizi tekrar giriniz."),
      roleId: Yup.string().required("Lütfen bir rol seçiniz."),
    }),

    onSubmit: async (values) => {
      try {
        const { confirmPassword, ...userData } = values;
        await dispatch(createUser(userData)).unwrap();
        setModal(false);
      } catch (error) {
        logger.error("Kullanıcı kaydı başarısız:", error);
      }
    },
  });

  return (
    <Fragment>
      <Button
        className="btn btn-label btn"
        color="primary"
        type="button"
        onClick={() => toggle_modal(true)}
      >
        <i className="ri-add-line label-icon align-middle me-2"></i>
        Kullanıcı Oluştur
      </Button>

      <Modal
        size="lg"
        isOpen={modal}
        toggle={() => {
          toggle_modal(false);
        }}
        centered
      >
        <ModalHeader
          className="modal-title"
          id="myLargeModalLabel"
          toggle={() => {
            toggle_modal(false);
          }}
        >
          Kullanıcı Oluştur
        </ModalHeader>

        <ModalBody className="p-4">
          <Form onSubmit={validation.handleSubmit} autoComplete="off">
            <Row className="gy-3">
              <Col lg={6}>
                <Label>Ad Soyad</Label>
                <Input
                  type="text"
                  name="nameSurname"
                  placeholder="Can Yılmaz"
                  maxLength={100}
                  value={validation.values.nameSurname}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.nameSurname &&
                      validation.errors.nameSurname
                    )
                  }
                />
                <FormFeedback>{validation.errors.nameSurname}</FormFeedback>
              </Col>

              <Col lg={6}>
                <Label>Telefon Numarası</Label>
                <InputGroup>
                  <span
                    className="input-group-text"
                    style={{
                      width: "44px",
                      justifyContent: "center",
                    }}
                  >
                    0
                  </span>
                  <IMaskInput
                    inputMode="numeric"
                    mask="000 000 00 00"
                    unmask={true}
                    name="phoneNumber"
                    placeholder="5XX XXX XX XX"
                    value={validation.values.phoneNumber}
                    className={`form-control ${validation.touched.phoneNumber &&
                        validation.errors.phoneNumber
                        ? "is-invalid"
                        : ""
                      }`}
                    style={{ zIndex: 0 }}
                    onAccept={(value) =>
                      validation.setFieldValue("phoneNumber", value)
                    }
                  />
                </InputGroup>
                {validation.touched.phoneNumber &&
                  validation.errors.phoneNumber && (
                    <div className="invalid-feedback d-block">
                      {validation.errors.phoneNumber}
                    </div>
                  )}
              </Col>

              <Col lg={6}>
                <Label>Şifre</Label>
                <InputGroup>
                  <span
                    className="input-group-text"
                    style={{ width: "44px" }}
                    id="inputGroupPrepend2"
                  >
                    <i
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        cursor: "pointer",
                        color: "gray",
                      }}
                      className={
                        showPassword
                          ? "ri-eye-off-fill align-middle"
                          : "ri-eye-fill align-middle"
                      }
                    ></i>
                  </span>
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control pe-5"
                    placeholder="******"
                    value={validation.values.password || ""}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.password && validation.errors.password
                        ? true
                        : false
                    }
                  />
                </InputGroup>
                {validation.touched.password && validation.errors.password && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.password}
                  </div>
                )}
              </Col>

              <Col lg={6}>
                <Label>Şifre Tekrar</Label>
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="Şifreyi tekrar giriniz"
                  value={validation.values.confirmPassword}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.confirmPassword &&
                      validation.errors.confirmPassword
                    )
                  }
                />
                <FormFeedback>{validation.errors.confirmPassword}</FormFeedback>
              </Col>

              <Col lg={12}>
                <Label>Rol</Label>
                <Select
                  name="roleId"
                  placeholder="Rol Seçiniz..."
                  options={roleOptions}
                  menuPlacement="auto"
                  value={
                    roleOptions.find(
                      (opt) => opt.value === validation.values.roleId
                    ) || null
                  }
                  onChange={(option) =>
                    validation.setFieldValue(
                      "roleId",
                      option ? option.value : ""
                    )
                  }
                  styles={getSelectStyles(validation, "roleId")}
                />
                {validation.touched.roleId && validation.errors.roleId && (
                  <div className="invalid-feedback d-block">
                    {validation.errors.roleId}
                  </div>
                )}
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                type="button"
                color="primary"
                onClick={() => validation.handleSubmit()}
                className="btn btn-label"
                disabled={createUserLoading}
              >
                <i className="ri-check-line label-icon align-middle me-2"></i>{" "}
                Oluştur
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AddModal;
